export const WordCarousel = (function () {
	'use strict';

	function init() {
		events();
		const carousels = document.querySelectorAll('[data-word-carousel]')
		carousels.forEach((carousel) => {
			const phrases = carousel.querySelectorAll('[data-phrase]')
			const items = []
			let id = null
			phrases.forEach((el) => {
				items.push({
					el,
					duration: el.getAttribute('data-phrase')
				})
			})
			const doNext = () => {
				if (id === null) {
					id = 0
				} else {
					items[id].el.classList.remove('active')
					id = (id + 1) % items.length
				}
				items[id].el.classList.add('active')
				setTimeout(doNext, items[id].duration)
			}
			doNext()
			carousel.classList.add('ready')
		})
	}

	function events() { }

	return {
		init: init,
	};
})();
